import React, { Component } from "react";
import Header from "../components/header/header";
import Footer from "../components/statics/footer";
import ProfessionalList from "../components/professional/professionalList";
import { connect } from "react-redux";
import * as ProfessionalProvider from "../providers/professionalProvider";
import { withRouter } from "react-router-dom";

class ProfessionalByCategoryScreen extends Component {
  constructor() {
    super();
    this.category = null;
    this.reloadedPage = false;
  }
  /* componentDidMount(){
    // if(this.props.history.location.state != undefined){
      console.log(this.props.categories);
      console.log('category', this.props.category)
      this.props.doGetProfessionals(this.props.category)
    // } else {
    //   this.props.history.goBack()
    // }
  } */

  componentDidMount() {
    this.getProfessionals();
  }

  getProfessionals = () => {
    const {
      match,
      categories,
      doGetProfessionals,
      subcategories,
      doGetProfessionalsBySubcategory
    } = this.props;

    if (categories.length === 0) {
      this.reloadedPage = true;
      return;
    }

    this.reloadedPage = false;

    const category = categories.find(item => item._id == match.params.id);
    if (category) {
      this.category = category;
      doGetProfessionals(category._id);
      return;
    }
    //this.category = subcategory;
    doGetProfessionalsBySubcategory(match.params.id);
    return;
    /* const subcategory = subcategories.find(item => item.ref.id == match.params.id);
    if(subcategory) {
      this.category = subcategory;
      doGetProfessionalsBySubcategory(subcategory.ref);
      return;
    } */
  };

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params.id !== match.params.id || this.reloadedPage) {
      this.getProfessionals();
    }
  }

  render() {
    return (
      <div>
        {/* <Header /> */}
        <ProfessionalList
          list={this.props.professionals}
          category={this.props.category}
          categoryName={this.category ? this.category.name : ""}
          history={this.props.history}
          categories={this.props.categories}
          groups={this.props.groups}
        />
        <Footer />
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doGetProfessionals: ref =>
      dispatch(ProfessionalProvider.getProfessionals(ref)),
    doGetProfessionalsBySubcategory: ref =>
      dispatch(ProfessionalProvider.getProfessionalsBySubcategory(ref))
  };
};
const mapStateToProps = state => {
  //console.log('props professional', state)
  return {
    professionals: state.professional.list,
    category: state.category.current_category,
    categories: state.category.list,
    subcategories: state.category.subcategories,
    groups: state.category.groups
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProfessionalByCategoryScreen));
